import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordService {

  private isResetModalVisibleSubject = new BehaviorSubject<boolean>(false);
  isResetModalVisible$ = this.isResetModalVisibleSubject.asObservable();

  showResetModal(): void {
    this.isResetModalVisibleSubject.next(true);
  }

  hideResetModal(): void {
    this.isResetModalVisibleSubject.next(false);
  }


}
